import { useState as d, useCallback as h } from "react";
import { sendToLurker as m } from "../../Lurker/Lurker.js";
var p = (i, c, o) => new Promise((r, n) => {
  var a = e => {
      try {
        t(o.next(e));
      } catch (l) {
        n(l);
      }
    },
    s = e => {
      try {
        t(o.throw(e));
      } catch (l) {
        n(l);
      }
    },
    t = e => e.done ? r(e.value) : Promise.resolve(e.value).then(a, s);
  t((o = o.apply(i, c)).next());
});
const u = () => {
  const [i, c] = d(0),
    [o, r] = d(0),
    n = h(() => p(void 0, null, function* () {
      try {
        const a = new Headers();
        a.set("x-olx-team-key", "5XzjuCgmYE7qMlYpsLZbTvm98ik4CS4a"), a.set("Cache-Control", "no-cache");
        const s = yield (yield fetch("https://apigw.olx.com.br/badge/notifications", {
            credentials: "include",
            headers: a
          })).json(),
          {
            chat: t,
            central: e
          } = s;
        t && (c(t), m({
          eventType: "impression",
          objectDetail: "badge",
          objectName: "chat",
          data: {
            notificationCount: t
          }
        })), e && (r(e), m({
          eventType: "impression",
          objectDetail: "badge",
          objectName: "notification"
        }));
      } catch (a) {}
    }), []);
  return [i, o, n];
};
export { u as useLoadNotificationsBadge };